import { render, staticRenderFns } from "./PrintDeliveryCollection.vue?vue&type=template&id=c8220ab8&"
import script from "./PrintDeliveryCollection.vue?vue&type=script&lang=js&"
export * from "./PrintDeliveryCollection.vue?vue&type=script&lang=js&"
import style0 from "./PrintDeliveryCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports